import { render, staticRenderFns } from "./registerCampania.vue?vue&type=template&id=385f028a&scoped=true&"
import script from "./registerCampania.vue?vue&type=script&lang=js&"
export * from "./registerCampania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f028a",
  null
  
)

export default component.exports